export default __webpack_public_path__ + "static/media/Mark-5-HUD-Altitude Range.dbecec72.jpg";